// extracted by mini-css-extract-plugin
export var header = "_u4-1";
export var maskBottom = "_u4-6";
export var maskMiddle = "_u4-7";
export var maskTop = "_u4-5";
export var root = "_u4-0";
export var scrollDownButton = "_u4-3";
export var scrollDownButtonHidden = "_u4-4";
export var viewport = "_u4-2";